import { FormatDate, FormatDateShort } from "utils/dateUtils";
import { useSelector } from "react-redux";
import { FormatNumber } from "utils/numberUtils";
import { getAllPayablePlans, selectState } from "../main.slice";
import { useAppDispatch } from "hooks/hooks";
import React, { useEffect } from "react";

const PrintPayablesPlan = () => {
  const { partners, planPayables, payablesPlanAmount } = useSelector(selectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAllPayablePlans());
  }, [partners]);

  return (
    <>
      <div className="partners-payables-print">
        <div className="payables-header">PLAN PLAĆANJA</div>
        <div className="payables-date">
          {FormatDate(new Date().toISOString())}
        </div>
        <div className="payables-list">
          {planPayables.map((plan, index) => {
            return (
              <div className="single-payable" key={index}>
                <div className="top">
                  <div className="name">
                    <label>{plan.partnerName}</label>
                    <label>
                      {plan.payablesTotalOutstandingAmount &&
                        FormatNumber(plan.payablesTotalOutstandingAmount)}
                    </label>
                  </div>
                  <div className="amount">
                    <label>
                      {plan.paymentsPlanAmount &&
                        FormatNumber(plan.paymentsPlanAmount)}
                    </label>
                  </div>
                  <div className="bank">
                    <label>{plan.bankAccount}</label>
                  </div>
                </div>
                <div className="bot">
                  {plan.plannedPayables &&
                    plan.plannedPayables.map((pay, subIndex) => {
                      return (
                        <div className="bot-row" key={subIndex}>
                          <div>{FormatDateShort(pay.dueDate)}</div>
                          <div>{FormatNumber(pay.outstandingAmount)}</div>
                          <div>{pay.isXxx && (<input type="checkbox" checked />)}</div>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
        </div>
        <div className="payables-total">
          <span>
            <label>ukupno</label>
            <label>{FormatNumber(payablesPlanAmount || 0)}</label>
          </span>
        </div>
      </div>
    </>
  );
};

export default PrintPayablesPlan;
